<div class="bg-lBlack light:bg-lGray950 border border-lGray800 rounded-2xl p-5 h-full min-h-[11.5rem] flex flex-col">
  <div class="flex items-center gap-3 mb-2">
    <span class="w-9 h-9 rounded-xl bg-lGray700 flex items-center justify-center shrink-0">
      <l-icon class="text-lWhite text-lg leading-none">{{ metric.icon }}</l-icon>
    </span>
    <p class="text-color text-base font-semibold">{{ metric.title }}</p>
  </div>

  <div
    echarts
    [theme]="theme"
    [options]="chartOptions"
    class="w-full h-48 flex-1"
  ></div>
</div>
